import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import { useApiClient } from "../../contexts/ApiClientContext";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import Loading from "../common/Loading";
import UserRoles from "../../model/enums/UserRole";
import { User } from "../../model/User";
import UsersListElement from "./UsersListElement";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";

/*
  Component to manage the display of the existing Users list
*/
function UsersList() {
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // activities information to be displayed
  const [data, setData] = useState<User[]>([]);
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    apiClient
      ?.get<PagedData<User[]>>({
        url: APIEndPoints.USERS.ALL,
        requiresToken: true,
      })
      .then((response: PagedData<User[]>) => {
        // filter all data by role!=admin
        const non_admins = response.items.filter(
          (user) => user.role !== UserRoles.ADMIN,
        );
        setData(non_admins);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient, navigate]);

  const refreshList = () => {
    setLoading(true);
    apiClient
      ?.get<PagedData<User[]>>({
        url: APIEndPoints.USERS.ALL,
        requiresToken: true,
      })
      .then((response: PagedData<User[]>) => {
        const non_admins = response.items.filter(
          (user) => user.role !== UserRoles.ADMIN,
        );
        setData(non_admins);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {/* <h3 className="text-left">Create New Material:</h3>
      <div className="grid grid-cols-4 gap-6">
        <UsersListElement
          canEdit={true}
          navigable={true}
          onDelete={refreshList}
        />
      </div> */}

      <h3 className="text-left">Existing Users:</h3>
      <br></br>

      <div>
        {data?.length > 0 &&
          data?.map((item) => {
            const canEdit =
              authManager.getUserRole() === UserRoles.ADMIN &&
              !EmbeddingToolInfo.isChemiTool();
            return (
              <UsersListElement
                key={item.id}
                data={item}
                canEdit={canEdit}
                navigable={true}
                onDelete={refreshList}
              />
            );
          })}

        {data?.length === 0 && (
          <div className="col-span-4 text-center text-gray-600">
            No Users available.
          </div>
        )}
      </div>
    </div>
  );
}

export default UsersList;
